import { Loader, useMantineTheme } from '@mantine/core';
import { IconCheck, IconCircleDashed, IconX } from '@tabler/icons-react';
import type { ReactNode } from 'react';

import { STEP_STATUS_UI } from '../constants/conversionTracking';

import type { StepStatus } from '../types';

interface IUseStepStylesParams {
  type?: 'parent' | 'sub';
}

interface IStepStyle {
  color: string;
  icon: ReactNode;
  iconSize: 'lg' | 'sm';
  titleSize: 'md' | 'sm';
}

export type StepStyles = Record<StepStatus, IStepStyle>;

export function useStepStyles({ type = 'parent' }: IUseStepStylesParams): StepStyles {
  const theme = useMantineTheme();
  const commonStyles = {
    iconSize: type === 'parent' ? 'lg' : 'sm',
    titleSize: type === 'parent' ? 'md' : 'sm',
  } as const;
  const getColor = (status: StepStatus) => theme.colors[STEP_STATUS_UI[status].color][5];

  return {
    notStarted: {
      ...commonStyles,
      color: getColor('notStarted'),
      icon: <IconCircleDashed size={16} stroke={3} color={getColor('notStarted')} />,
    },
    inProgress: {
      ...commonStyles,
      color: getColor('inProgress'),
      icon: <Loader size={16} color={getColor('inProgress')} />,
    },
    actionRequired: {
      ...commonStyles,
      color: getColor('actionRequired'),
      icon: <IconCircleDashed size={16} stroke={3} color={getColor('actionRequired')} />,
    },
    done: {
      ...commonStyles,
      color: getColor('done'),
      icon: <IconCheck size={16} stroke={3} color={getColor('done')} />,
    },
    fail: {
      ...commonStyles,
      color: getColor('fail'),
      icon: <IconX size={16} stroke={3} color={getColor('fail')} />,
    },
  };
}
